import React from 'react';
import classNames from 'classnames/bind';
import styles from '../components/text-an-expert.module.scss';

let cx = classNames.bind(styles);

export const Android = () => (
  <a className={cx('business-chat__link')} href="sms:38698">
    <div className={cx('banner')}>
      <div className={cx('banner__icon')} />
      <div className={cx('banner__text')}>
        <span>TEXT A HOME DEPOT EXPERT</span>
      </div>
      <div className={cx('banner__android')} />
    </div>
  </a>
);
